import React from 'react'
import { Link, useParams } from 'react-router-dom'
import Appbar from '../../components/Appbar'
import { womanProducts } from '../../data/ProductData'


const WSingleExt = () => {
    const {id} = useParams()
  const product = womanProducts.find((p) => p.id === id);

  if (!product) {
    return <div>Product not found</div>;
  }

  return (
    <div>
      <Appbar />
      <div className="bread-sec">
        <Link to="/" className="bread-link">
          <u>Home</u>
        </Link>
        <Link to="/mens" className="bread-link">
          <u>Men</u>
        </Link>
        <Link to="/woman" className="bread-link">
          <u>back</u>
        </Link>
      </div>
    <div className="pro-title">{product.proName}</div>
    <div className="single-pro">
      <div className="pro-show mob-pro-show">
      <img src={product.block2} alt={product.proName} />
    <img src={product.block3} alt={product.proName} />
    <img src={product.block4} alt={product.proName} />
    <img src={product.block5} alt={product.proName} />
      </div>
      <div className="pro-detail">
        <div className="pro-price">
          ₹ 899 <span>Inclusive of all taxes</span> <br />
          <div className="pro-discount">
            ₹ 1799 Save ₹ 900 (50.03%) <br />
            <a href="">Free shipping on orders above INR 498</a>
          </div>
        </div>
        <br /><br />
        <div className="def-pro">
          <div className="def-pic">
            <img src="assets/SinglePro/track-1.jpg" alt="" />
          </div>
          <div className="def-color">
            <div>Color: Green</div>
            <div>Order now, Only 3 Left!</div>
          </div>
        </div>
        <br />
        <br />
        <div className="def-color">
          <div>Size:</div>
          <div>
            <a href="">Size Guide</a>
          </div>
        </div>
        <div className="def-size">
          <span>
            <strike>S</strike>
          </span>
          <span>M</span>
          <span>
            <strike>L</strike>
          </span>
          <span>
            <strike>XL</strike>
          </span>
          <span>
            <strike>XXL</strike>
          </span>
        </div>
        <div className="pro-basket">
          <span>Add to Basket</span>
        </div>
        <br />
        <div className="def-color">
          <div>
              like
          </div>
          <div>
              <span>|</span>
              Share
          </div>
        </div>
        <hr />
        <div className="pro-promo">
          <button>PROMOTION OFFER</button> <br /><br />
          <div>
          Save 12% on Rs.2,999, Code - SAVE12 | Save 8% on Rs.1,999, Code - SAVE8 | Save 5% on Rs.1,499, Code - SAVE5 Browse promotion
          </div>
        </div>
        <hr />
        <div className="pro-list">
         <div>
          <figure></figure>
          <span>Click & Collect</span> <br />
          Order this product now and collect it from a store of your choice. 
          <a href=""> Learn more</a>
         </div>
         <div>
          <figure></figure>
          <span>Click & Collect</span> <br />
          Order this product now and collect it from a store of your choice. 
          <a href=""> Learn more</a>
         </div>
         <div>
          <figure></figure>
          7 days easy return policy.
          <a href=""> Learn more</a>
         </div>
         <div>
          <figure></figure>
          <span>Pay in installments</span> <br />
          Pay in easy installments on orders of ₹ 3,000 or more. Available for select banks.
          <a href=""> Learn more</a>
         </div>
         <div className="def-inp">
          <figure></figure>
          When will I receive my order? <br />
          <input type="text" placeholder="Enter you Pincode"/>
          <button>Check</button>
         </div>
        </div>
      </div>
    </div>
  </div>
 
  )
}

export default WSingleExt